import useChatStore from '@/Components/Chat/store';
import useGetModelsIcons from '@/Hooks/useGetModelsIcons';
import StraicoSymbolIcon from '@/Theme/icons/straicoSymbol';
import useThemeStore from '@/Theme/store';
import { ArrowTopRightOnSquareIcon, UserIcon } from '@heroicons/react/24/solid';
import { Button, Menu, MenuItem } from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';

const CombosModalSelector = ({
  combos,
  loading,
  anchorEl,
  setAnchorEl,
  customWidth,
  handleMenuClose,
  handleComboClick,
  setPowerPanelOpen,
  ...props
}) => {
  const navigate = useNavigate();
  const { getIcon } = useGetModelsIcons();

  const { theme: themeValue } = useThemeStore();
  const { isStraicoCombo, allModels } = useChatStore((state) => state);

  const handleNavigation = (path) => {
    navigate(path);
    setTimeout(() => {
      const targetSection = document.querySelector('#wordcapLimitsSection');
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: 'smooth' });
        targetSection.focus();
      }
    }, 500);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      PaperProps={{
        style: {
          maxHeight: 'auto',
          overflow: 'hidden',
          width:
            customWidth ||
            (anchorEl ? `${anchorEl.clientWidth + 80}px` : '300px'),
          backgroundColor: themeValue === 'dark' ? '#252425' : '#FBFBFA',
          border: '1.5px solid #9091A461',
          borderRadius: '10px',
          boxShadow: 'none',
        },
        elevation: 0,
      }}
      {...props}
    >
      {loading && <MenuItem disabled>Loading combos...</MenuItem>}
      {!loading && combos.length === 0 && (
        <MenuItem disabled>No combos available</MenuItem>
      )}
      {!loading && combos.length > 0 && (
        <>
          <div
            style={{
              maxHeight: '200px',
              overflowY: 'auto',
              backgroundColor: themeValue === 'dark' ? '#252425' : '#FBFBFA',
            }}
          >
            {combos
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((combo) => (
                <MenuItem
                  key={combo._id}
                  onClick={() => handleComboClick(combo)}
                  sx={{
                    backgroundColor:
                      themeValue === 'dark' ? '#252425' : '#FBFBFA',
                    color: themeValue === 'dark' ? '#FFFFFF' : '#211E21',

                    borderRadius: '6px',
                    my: '4px',
                    px: '16px',
                    py: '8px',

                    fontSize: '14px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s ease',

                    '&:hover': {
                      backgroundColor:
                        themeValue === 'dark' ? '#3B3B45' : '#EDEDF2',
                    },
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <div
                        style={{
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {isStraicoCombo(combo._id) ? (
                          <StraicoSymbolIcon
                            style={{
                              width: '16px',
                              height: '16px',
                              fill: '#464BBA',
                            }}
                            title="Straico Combo"
                          />
                        ) : (
                          <UserIcon className="w-[16px] h-[16px] text-cool-gray" />
                        )}
                      </div>
                      <span
                        style={{
                          maxWidth: 160,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {combo.name}
                      </span>
                    </div>

                    <div style={{ display: 'flex', gap: '4px' }}>
                      {combo.llms &&
                        combo.llms.map((llmId) => {
                          const model = allModels.find((m) => m._id === llmId);
                          return model ? (
                            <span
                              key={llmId}
                              title={model.name}
                              style={{
                                width: '16px',
                                height: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {getIcon(model.icon)}
                            </span>
                          ) : null;
                        })}
                    </div>
                  </div>
                </MenuItem>
              ))}
          </div>
          <div
            style={{
              textAlign: 'center',
              backgroundColor: themeValue === 'dark' ? '#252425' : '#FBFBFA',
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                handleNavigation('/llm-settings');
                setPowerPanelOpen(false);
                setAnchorEl(null);
              }}
              startIcon={
                <ArrowTopRightOnSquareIcon
                  style={{
                    width: 20,
                    height: 20,
                    color: themeValue === 'dark' ? '#7F82C3' : '#5256A6',
                  }}
                />
              }
              style={{
                backgroundColor: themeValue === 'dark' ? '#3B3B45' : '#D4D5E6',
                color: themeValue === 'dark' ? '#7F82C3' : '#5256A6',
                textTransform: 'none',
                width: '90%',
                height: '40px',
                boxShadow: 'none',
                fontSize: '13px',
              }}
              PaperProps={{
                style: {
                  boxShadow: 'none',
                },
                elevation: 0,
              }}
            >
              Go to settings page
            </Button>
          </div>
        </>
      )}
    </Menu>
  );
};

export default memo(CombosModalSelector);
